import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "xml:space": "preserve",
  viewBox: "0 0 32 32"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("circle", {
      cx: "16",
      cy: "16",
      r: "13.7",
      style: {"fill":"#0f4e99","stroke":"#fff","stroke-width":"2","stroke-miterlimit":"10"}
    }, null, -1),
    _createElementVNode("path", {
      d: "M15.2 8.3c.1-.3.4-.5.8-.5s.7.2.8.5l1.7 3.5c.1.3.4.5.7.5l3.9.6c.4.1.6.3.8.6.1.3 0 .7-.2 1l-2.8 2.7c-.2.2-.3.5-.3.8l.7 3.9c.1.4-.1.7-.4.9s-.7.2-1 .1l-3.5-1.8q-.45-.15-.9 0L12.1 23c-.3.2-.7.1-1-.1s-.4-.6-.4-.9l.7-3.9c.1-.3 0-.6-.3-.8l-2.8-2.7c-.3-.2-.3-.6-.2-1 .1-.3.4-.6.8-.6l3.9-.6c.3 0 .6-.2.7-.5z",
      style: {"fill":"#fff"}
    }, null, -1)
  ])))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "mapmarker-blue-w-star"}) } }